import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { UserPermissionService } from './user-permission.service';

@Injectable({
  providedIn: 'root',
})
export class ComponentPermissionService {
  constructor(
    private userPermissionService: UserPermissionService,
    private router: Router,
    private toastrService: NbToastrService
  ) {}

 
  checkCurrentPageAccess(): boolean {
    const currentUrl = this.router.url;
    const path = this.normalizePath(currentUrl);
    
  
    if (path === 'admin' || path === '' || path === '/admin') {
      return true;
    }

    if (!this.userPermissionService.arePagesLoaded()) {
      console.log('Pages not loaded yet, waiting...');
      return true;
    }

    const hasAccess = this.userPermissionService.hasAccessToPage(path);
    
    if (!hasAccess) {
      this.showUnauthorizedMessage();
      this.router.navigate(['/admin'], { replaceUrl: true });
      return false;
    }

    return true;
  }


  hasAccessToPage(path: string): boolean {
    return this.userPermissionService.hasAccessToPage(path);
  }

  navigateToPage(path: string): boolean {
    if (this.hasAccessToPage(path)) {
      this.router.navigate([path]);
      return true;
    } else {
      this.showUnauthorizedMessage();
      return false;
    }
  }

  private showUnauthorizedMessage(): void {
    this.toastrService.danger(
      'You do not have permission to access this page.',
      'Access Denied',
      {
        duration: 5000,
        status: 'danger'
      }
    );
  }

  private normalizePath(path: string): string {
    return path ? path.replace(/^\/+/, '') : '';
  }
}
